import * as go from 'gojs';

import { ContextMenuData } from 'src/containers/ProjectDiagram/types/contextMenu';
import {
  isLink,
  isLinkLabel,
  isNode,
} from 'src/containers/ProjectDiagram/utils/graphObject';

const showContextMenuOnMouse = (
  e: go.InputEvent,
  obj: go.Node | go.Group | go.Link,
  setContextMenu: (_: ContextMenuData) => void
) => {
  // mouse position
  const { x: left, y: top } = e.viewPoint;
  setContextMenu({
    obj,
    left,
    top,
  });
};

export const showContextMenu =
  (
    _div: HTMLElement,
    setContextMenu: (_: ContextMenuData) => void
  ): NonNullable<go.HTMLInfo['show']> =>
  (obj, diagram, _tool) => {
    if (obj == null || !(isNode(obj) || isLink(obj) || isLinkLabel(obj))) {
      return;
    }

    const e = diagram.lastInput;

    // only show context menu if no modifier keys are being held,
    // control-click acts as right click on mac
    if (!e.modifiers || e.control) {
      showContextMenuOnMouse(e, obj, setContextMenu);
    } else {
      // on mac, pressing the meta key will open context menu
      // on currently selected part or background,
      // so cancel this kind of event
      diagram.toolManager.contextMenuTool.doCancel();
    }
  };

export const hideContextMenu =
  (
    setContextMenu: (_: ContextMenuData | null) => void
  ): NonNullable<go.HTMLInfo['hide']> =>
  (_diagram, _tool) => {
    setContextMenu(null);
  };
